import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAdminUsers, getUsers } from '../../services/UsersService';
import { User } from '../../types/Users';
import { getSimpleEqQuery } from '../../../utils/queryFilters';
import useGetRole from '../useGetRole';

function useGetCurrentUser(fleetId: string, email?: string): UseQueryResult<User | undefined> {
  const { isAdmin, isSupport } = useGetRole();
  const useAdminPortal = isAdmin || isSupport;

  return useQuery(
    ['current-user', fleetId, email, useAdminPortal],
    async (): Promise<User | undefined> => {
      const query = `?limit=1&skip=0${getSimpleEqQuery('email', email, 0)}`;
      const { results } = useAdminPortal
        ? await getAdminUsers(query)
        : await getUsers(fleetId, query);
      return results[0];
    },
    {
      retry: 1,
      retryDelay: 3000,
      enabled: !!email && (useAdminPortal || !!fleetId),
    },
  );
}

export default useGetCurrentUser;
